module.exports = __webpack_public_path__ + "img/HD_title_zyq_2_d3b1e6816.png";